import { useEffect } from "react"
import { useDispatch } from "react-redux"
import { AppDispatch } from "../store/store"
import { getLocalStorageItem, setLocalStorageItem } from "../utils/local_storage/local_storage"
import { setTableId, updateCartInitialState } from "../store/shop_order/shopOrderSlice"
import useParam from "../hooks/useParam"
import { Outlet } from "react-router"

const TTL = 2 * 60 * 60 * 1000 // 2 hours

const LocalStorageProvider = () => {

    const tableId = useParam("table")
    const dispatch = useDispatch<AppDispatch>()

    useEffect(() => {

        const now = new Date()

        // CART LOCAL STORAGE
        // Update the store cart with the cart in local storage on refresh or new visit
        const localStorageCart = getLocalStorageItem("cart")
        localStorageCart && dispatch(updateCartInitialState(localStorageCart))

        // TABLE ID LOCAL STORAGE
        if (tableId) setLocalStorageItem("table-id", tableId)

        console.log("table id >>>> ",)

        // USER ORDERS LOCAL STORAGE
        // Delete the orders in the users orders history list after TTL or so
        const checkExpiry = () => {

            const localStorageOrders = getLocalStorageItem("orders")

            if (localStorageOrders && now.getTime() > localStorageOrders.expiry) {
                localStorage.removeItem("orders")
            }
        }

        checkExpiry()

        // Check for expiration every TTL or so
        const checkExpiryInterval = setInterval(checkExpiry, TTL);

        return () => {
            clearInterval(checkExpiryInterval)
        };

    }, [dispatch])

    return <Outlet />
}

export default LocalStorageProvider